import { useEffect } from 'react';
import { hasDocument, hasWindow } from '../utils';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { doesUserConsentToRetargeting } from '../user/consents/consent-reducer';

const useFacebookPixel = () => {
    const scriptId = 'facebookPixelScript';
    const pixelTrackingId = useSelector((state) => state.facebookPixelTrackingId);
    const consentedToRetargeting = useSelector((state) => doesUserConsentToRetargeting(state));

    const { pathname } = useLocation();
    const isDocumentAvailable = hasDocument();
    const currentScript = isDocumentAvailable && document?.getElementById(scriptId);
    const fbqExists = hasWindow() ? !!window?.fbq : false;

    useEffect(() => {
        if (currentScript || !isDocumentAvailable || !consentedToRetargeting) {
            return;
        }
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.defer = !0;
            t.src = v;
            t.id = scriptId;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }, [currentScript, isDocumentAvailable, consentedToRetargeting]);

    useEffect(() => {
        if (pixelTrackingId && fbqExists && consentedToRetargeting) {
            window.fbq('init', pixelTrackingId);
        }
    }, [pixelTrackingId, fbqExists, consentedToRetargeting]);

    useEffect(() => {
        if (pixelTrackingId && fbqExists && consentedToRetargeting) {
            window.fbq('track', 'PageView', pathname);
        }
    }, [pixelTrackingId, pathname, fbqExists, consentedToRetargeting]);

    return currentScript;
};
export default useFacebookPixel;
